'use strict';

const switchingJobStatuses = {
  pending: 'pending',
  inProgress: 'in-progress',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
  timedOut: 'timed-out',
};

const terminalSwitchingJobStatuses = new Set([
  switchingJobStatuses.completed,
  switchingJobStatuses.failed,
  switchingJobStatuses.cancelled,
  switchingJobStatuses.timedOut,
]);

// Terminal statuses that represent an actual failure — excludes 'completed', which
// is terminal but not an error.
const failureSwitchingJobStatuses = new Set([
  switchingJobStatuses.failed,
  switchingJobStatuses.cancelled,
  switchingJobStatuses.timedOut,
]);

module.exports = {
  ...switchingJobStatuses,
  terminalSwitchingJobStatuses,
  failureSwitchingJobStatuses,
};
